export type TTournamentStatus =
  | 'planning'
  | 'planned'
  | 'open'
  | 'in_progress'
  | 'completed'
  | 'cancelled';

export type TSlotStatus = 'scheduled' | 'ongoing' | 'completed' | 'cancelled';

export type TStatusTone = 'plan' | 'open' | 'live' | 'done' | 'off' | 'alert';

export interface IStatusInfo {
  label: string;
  tone: TStatusTone;
}

export const TOURNAMENT_STATUS: Record<TTournamentStatus, IStatusInfo> = {
  planning: { label: 'Em planejamento', tone: 'plan' },
  planned: { label: 'Em planejamento', tone: 'plan' },
  open: { label: 'Aberto', tone: 'open' },
  in_progress: { label: 'Em andamento', tone: 'live' },
  completed: { label: 'Concluído', tone: 'done' },
  cancelled: { label: 'Cancelado', tone: 'off' },
};

export const SLOT_STATUS: Record<TSlotStatus, IStatusInfo> = {
  scheduled: { label: 'Agendado', tone: 'open' },
  ongoing: { label: 'Em andamento', tone: 'live' },
  completed: { label: 'Concluído', tone: 'done' },
  cancelled: { label: 'Cancelado', tone: 'off' },
};

export const DISQUALIFIED_STATUS: IStatusInfo = {
  label: 'Desclassificada',
  tone: 'alert',
};

/** Status desconhecido devolve null: a tela nunca mostra o enum cru. */
export const tournamentStatus = (status?: string | null): IStatusInfo | null =>
  TOURNAMENT_STATUS[status as TTournamentStatus] ?? null;

export const slotStatus = (
  status?: string | null,
  disqualified = false,
): IStatusInfo | null => {
  if (disqualified) return DISQUALIFIED_STATUS;
  return SLOT_STATUS[status as TSlotStatus] ?? null;
};
